<script>
import ModelCreate from "../models/create";
import FormsModel from "@/components/forms/company";

export default {
  extends: ModelCreate,
  page: {
    title: "Create Companies",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('companies.singular')) }},
    resourceRoute: {default: 'companies'},
    modelVariable: {default: 'company'},
    form: {default() { return FormsModel; }}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('companies.plural')),
      items: [
        {
          text: this.lodash.upperFirst(this.$t('companies.plural')),
          href: "/companies",
        },
        {
          text: this.$t("Create New"),
          href: "/companies/create",
          active: true,
        },
      ]
    }
  },
  methods: {
    store(value) {
      return this.$axios.post('/companies', value);
    }
  }
}
</script>
